export const watchdog = {
    subject: {
        SIZE: 'size',
        PRICE: 'price',
    },
};
